
var isFlipActive = false;
function checkFlip() {
  if( $(window).width() >= 767 && !isFlipActive ){
    console.log('desktop');
    $('.card').flip({
      trigger: 'hover'
    }); 
    isFlipActive = true;
  }
  else if( $(window).width() < 767 && isFlipActive ){
    console.log('mobile');
    $('.card').flip(false);
    $('.card').off('.flip');
    $('.card .back').css('transform','rotateY(0deg)');
    isFlipActive = false;
  }
}

function checkMobileMenuHeight(){
  windowHeight = $(window).height();
  $('.mobileMenuContainer').css('height', (windowHeight-98)+'px');
}

$(function(){

  //comportamiento del menu en scroll
  $(document).scroll(function(){
    if($(document).scrollTop() > 50 && !$('.topbar').hasClass('topbar_shrink')){
      $('.topbar').addClass('topbar_shrink');
      $('.mainmenu').addClass('mainmenu_blue');
      $('.hidden_on_top').removeClass('hidden_item');
      $('.hidden_on_scroll').addClass('hidden_item');
    }
    if($(document).scrollTop() <= 50 && $('.topbar').hasClass('topbar_shrink')){
      $('.topbar').removeClass('topbar_shrink');
      $('.mainmenu').removeClass('mainmenu_blue');
      $('.hidden_on_top').addClass('hidden_item');
      $('.hidden_on_scroll').removeClass('hidden_item');
    }
  });

  //ajustar menu mobile
  checkMobileMenuHeight();
  $(window).resize(function(){
    checkMobileMenuHeight();
  });

  //funciones del buscador
  $(".buscador").click(function(e){
      e.preventDefault();
      $('.searchmenu').fadeIn(500);
      $('.mainmenuOverTop').fadeOut(500);
  });

  $(".cerrador").click(function(e){
      e.preventDefault();
      $('.searchmenu').fadeOut(500);
      $('.mainmenuOverTop').fadeIn(500);
  });

  //scrollspy
  getUrl = window.location;
  //console.log(getUrl.origin);
  if($('#homepage').length > 0){
    /*
    $('.mainmenuLeft a').click(function(e){       
      var href = $(this).attr('href'); 
      var hash = '#' + (href.indexOf("#") != -1 ? href.substring(href.indexOf("#")+1) : "");
      if(hash){
        e.preventDefault();
        $('body,html').stop(true,true).animate({        
            scrollTop: $(hash).offset().top - 80
        },500, "swing");
      }
    });
    */
    $(".mainmenuLeft, .mainMenuMobile").scrollspy({ offset: 20, animate: true });
  }

  //funciones del tab de twitter
  $(".twitterBoxTab a").click(function(e){
    e.preventDefault();
    if($(".twitterBox").hasClass("twitterBoxClosed")){
      $(".twitterBox").removeClass("twitterBoxClosed");
    }
    else {
      $(".twitterBox").addClass("twitterBoxClosed");
    }
  });

  //activacion del flip
  checkFlip();
  $(window).resize(function(){
    checkFlip();
  });

  //animacion del menu mobile
  $('.hamburger').click(function(e){
    $('.hamburger').toggleClass('is-active');
    $('.mobileMenuContainer').toggleClass('show');
  });

  // Add slideDown animation to Bootstrap dropdown when expanding.
  $('.dropdown').on('show.bs.dropdown', function() {
    $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
  });

  // Add slideUp animation to Bootstrap dropdown when collapsing.
  $('.dropdown').on('hide.bs.dropdown', function() {
    $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
  });

  //cierre del menu mobile en item click
  $('.mobileMenuContainer a.dropdown-item, .mobileMenuContainer a.nav-link:not(.dropdown-toggle), .mobileMenuContainer .clasificacionPaises .institucion a').click(function(){
    $('.hamburger').click();
  });

});

